import type { ComponentProps } from 'react';
import React from 'react';
import { SingleComboBox } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import type { DealSearchCondition } from '~/models/Deal';
import { useVendorPartners } from '~/hooks/vendors/useVendorPartners';
import type { VendorPartner } from '~/models/VendorPartner';
import { convertToComboBoxOption } from '~/models/VendorPartner';

type Props = {
  dealSearchCondition: DealSearchCondition;
};
type SingleComboBoxOption = Exclude<
  ComponentProps<typeof SingleComboBox>['options'][number],
  { group: string }
>;

export const VendorPartnerCombobox: React.FC<Props> = ({
  dealSearchCondition
}: Props) => {
  const { data: vendorPartners } = useVendorPartners().index();
  const { setValue } = useFormContext<DealSearchCondition>();
  const noVendorPartnerOption: SingleComboBoxOption = {
    label: '実施会社未指定',
    value: String(-1)
  };
  const vendorPartnerOptions: SingleComboBoxOption[] = [
    noVendorPartnerOption
  ].concat(
    vendorPartners?.map((vp: VendorPartner) => convertToComboBoxOption(vp)) ||
      []
  );
  const [selectedVendorPartnerOption, setSelectedVendorPartnerOption] =
    React.useState<SingleComboBoxOption | null>(
      vendorPartnerOptions.find(
        ({ value }) => value === String(dealSearchCondition.partnerVendorId)
      ) || null
    );
  const onChangeVendorPartner = React.useCallback(
    async (option: SingleComboBoxOption | null): Promise<void> => {
      setSelectedVendorPartnerOption(option);
      setValue('partnerVendorId', option ? Number(option.value) : undefined);
    },
    [setValue]
  );
  if (vendorPartners === null) {
    return null;
  }
  return (
    <>
      <SingleComboBox
        defaultValue={selectedVendorPartnerOption}
        onChange={onChangeVendorPartner}
        options={vendorPartnerOptions}
        placeholder="実施会社"
        value={selectedVendorPartnerOption}
      />
    </>
  );
};
